<template>
    <div>
        <contratos :dataServico="obterDataServicos()"></contratos>
    </div>
</template>

<script>
import ContratosServicos from './ContratosServicos'
import Contratos from '../../gescon/contratos/Contratos'

export default {
    data() {
        return {}
    },
    methods: {
        obterDataServicos() {
            return ContratosServicos
        }
    },

    created() {},

    computed: {},

    watch: {},

    components: {
        Contratos
    }
}
</script>
